//nomal pickup dropoff
import icon_purpleO from "@/assets/diapatch/task/pin(5).svg";
import icon_unassignO from "@/assets/diapatch/task/unassignO.png";
import icon_buleO from "@/assets/diapatch/task/bule.png"
import icon_greenO from "@/assets/diapatch/nomal/icon_greenO.png"
import icon_redO from "@/assets/diapatch/nomal/icon_redO.png"

import icon_unassignP from "@/assets/diapatch/task/unassignP.png"
import icon_purpleP from "@/assets/diapatch/task/pin(1).svg";
import icon_buleP from "@/assets/diapatch/task/pin(2).svg";
import icon_redP from "@/assets/diapatch/task/pin(3).svg";
import icon_greenP from "@/assets/diapatch/task/pin(4).svg";
//高亮icon
import icon_unassign_pichup_border from "@/assets/diapatch/while_border/unassigner_p_border.png"
import icon_unassign_dropoff_border from "@/assets/diapatch/while_border/unassigned_d_border.png"
import icon_assign_dropoff_border from "@/assets/diapatch/while_border/purpole_d_border.png"
import icon_assign_pickup_border from "@/assets/diapatch/while_border/purpole_p_border.png"
import icon_intansit_pickup_border from "@/assets/diapatch/while_border/blue_p_border.png"
import icon_intansit_dropoff_border from "@/assets/diapatch/while_border/blue_d_border.png"
import icon_complete_pickup_border from "@/assets/diapatch/while_border/green_p_border.png"
import icon_complete_dropoff_border from "@/assets/diapatch/while_border/green_d_border.png"
import icon_fail_pickup_border from "@/assets/diapatch/while_border/red_p_border.png"
import icon_fail_dropoff_border from "@/assets/diapatch/while_border/red_d_border.png"
//dak icon

import icon_purpleO_D from "@/assets/diapatch/darl/icon_purplePO.png"
import icon_redO_D from "@/assets/diapatch/darl/icon_redO.png"
import icon_greenO_D from "@/assets/diapatch/darl/icon_greenO.png"
import icon_buleO_D from "@/assets/diapatch/darl/icon_buleO.png"
import icon_unassignO_D from "@/assets/diapatch/darl/icon_unassignO.png"


import icon_purplePD from "@/assets/diapatch/highlight/pin(3).svg"
import icon_buleD from "@/assets/diapatch/highlight/pin(2).svg";
import icon_redD from "@/assets/diapatch/highlight/pin(4).svg";
import icon_greenD from "@/assets/diapatch/highlight/pin(5).svg";
export default {
  getChangeIcon(task){
    //状态 0未指派 1指派中 2运输中 3完成 4失败
    // 灰色 未指派 紫色：已分配的任务 蓝色：运送中的任务 绿色：成功的任务 红色：失败的任务
    //任务类型 1pickup  0dropooff
    if (task.mean == 'normal'){
      if (task.is_pickup == 1){
        switch (task.status) {
          case 0:
            return icon_unassignO;
          case 1:
            return icon_purpleO;
          case 2:
            return icon_buleO;
          case 3:
            return task.success == 1? icon_greenO : icon_redO;
          case 4:
            return task.success == 1? icon_greenO : icon_redO;

        }
      }else if (task.is_pickup == 0){
        switch (task.status) {
          case 0:
            return icon_unassignP;
          case 1:
            return icon_purpleP;
          case 3:
            return task.success == 1? icon_greenO : icon_redO;
          case 2:
            return icon_buleP;
          case 4:
            return task.success == 1? icon_greenO : icon_redO;
        }
      }
      //高亮
    }else if (task.mean == 'highlight'){
      if (task.is_pickup == 1){
        switch (task.status) {
          case 0:
            return icon_unassign_pichup_border;
          case 1:
            return icon_assign_pickup_border;
          case 2:
            return icon_intansit_pickup_border;
          case 3:
            return task.success == 1? icon_complete_dropoff_border : icon_fail_dropoff_border;
          case 4:
            return task.success == 1? icon_complete_dropoff_border : icon_fail_dropoff_border;
        }
      }else if (task.is_pickup == 0){
        switch (task.status) {
          case 0:
            return icon_unassign_dropoff_border;
          case 1:
            return icon_assign_dropoff_border;
          case 2:
            return icon_intansit_dropoff_border;
          case 3:
            return task.success == 1? icon_complete_pickup_border : icon_fail_pickup_border;
          case 4:
            return task.success == 1? icon_complete_pickup_border : icon_fail_pickup_border;
        }
      }
      //透明
    }else{
      if (task.is_pickup == 1){
        switch (task.status) {
          case 0:
            return icon_unassignO_D;
          case 1:
            return icon_purpleO_D;
          case 2:
            return icon_buleP;
          case 3:
            return task.success == 1? icon_greenO : icon_redO;
          case 4:
            return task.success == 1? icon_greenO : icon_redO;
        }
      }else if (task.is_pickup == 0){
        switch (task.status) {
          case 0:
            return icon_purplePD;
          case 3:
            return task.success == 1? icon_greenO : icon_redO;
          case 4:
              return task.success == 1? icon_greenO : icon_redO;
          case 2:
            return icon_buleD;
        }
      }
    }
  }
}
